import { render, staticRenderFns } from "./SongChooser.vue?vue&type=template&id=5adbc078"
import script from "./SongChooser.vue?vue&type=script&lang=js"
export * from "./SongChooser.vue?vue&type=script&lang=js"
import style0 from "./SongChooser.vue?vue&type=style&index=0&id=5adbc078&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports